import { useEffect } from 'react';
import Pusher from 'pusher-js';
import { useSnackbar } from 'notistack';
import { dispatch } from '../redux/store';
import { openModal } from '../redux/slices/profileSlice';
import { conObjForm } from '../utils/connection-assistant';

// const usePusher = ({ uuid, enqueueSnackbar, navigate, setLoading }) => {
//   useEffect(() => {
//     if (!uuid) {
//       console.warn('Pusher skipped: No UUID yet');
//       return;
//     }

//     console.log('Initializing Pusher with UUID:', uuid);

//     const pusherKey = process.env.REACT_APP_PUSHER_APP_KEY;
//     const pusherCluster = process.env.REACT_APP_PUSHER_APP_CLUSTER;

//     console.log('--- Pusher Debug Start ---');
//     console.log('Target UUID (Channel):', uuid);
//     console.log('Pusher Key:', pusherKey);
//     console.log('Pusher Cluster:', pusherCluster);

//     if (!pusherKey) {
//       console.warn('Pusher Error: Missing App Key.');
//       return;
//     }

//     // 1. Initialize Pusher
//     const pusher = new Pusher(pusherKey, {
//       cluster: pusherCluster,
//       forceTLS: true,
//     });

//     // 2. Monitor Connection State
//     pusher.connection.bind('state_change', (states) => {
//       console.log('Pusher Connection State changed from', states.previous, 'to', states.current);
//     });

//     pusher.connection.bind('error', (err) => {
//       console.error('Pusher Connection Error:', err);
//     });

//     // 3. Subscribe to channel
//     const channel = pusher.subscribe(uuid);
//     console.log('Subscribed to channel:', uuid);

//     // Specific event binding
//     channel.bind(uuid, (data) => {
//       console.log('Received event on channel:', uuid);
//       console.log('Event Data:', data);

//       if (data && typeof data.success !== 'undefined') {
//         const isSuccess = data.success === true;

//         enqueueSnackbar(data.message || (isSuccess ? 'Success!' : 'Failed'), {
//           variant: isSuccess ? 'success' : 'error',
//         });
//       }
//     });

//     // Catch-all listener
//     channel.bind_global((uuid, data) => {
//       console.log('Incoming Event Detected!');
//       console.log('Event Name:', eventName);
//       console.log('Event Data:', data);

//       if (data && typeof data.success !== 'undefined') {
//         setLoading?.(false);

//         const isSuccess = data.success === true;

//         enqueueSnackbar(data.message || (isSuccess ? 'Success!' : 'Failed'), {
//           variant: isSuccess ? 'success' : 'error',
//         });

//         if (isSuccess) navigate('/');
//       }
//     });

//     // 5. Cleanup
//     return () => {
//       console.log('Cleaning up Pusher connection...');
//       channel.unbind_all();
//       channel.unsubscribe();

//       if (pusher.connection.state === 'connected') {
//         pusher.disconnect();
//       }
//     };
//   }, [uuid, enqueueSnackbar, navigate, setLoading]);
// };

const usePusher = ({ uuid, navigate, setLoading }) => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!uuid || !enqueueSnackbar) {
      console.warn('Pusher skipped: UUID or Snackbar not ready yet');
      return;
    }

    // console.log('Initializing Pusher with UUID:', uuid);

    const pusherKey = process.env.REACT_APP_PUSHER_APP_KEY;
    const pusherCluster = process.env.REACT_APP_PUSHER_APP_CLUSTER;

    if (!pusherKey) {
      console.warn('Pusher Error: Missing App Key.');
      return;
    }

    // 1. Initialize Pusher
    const pusher = new Pusher(pusherKey, {
      cluster: pusherCluster,
      forceTLS: true,
    });

    // 2. Debug connection
    // pusher.connection.bind('state_change', (states) => {
    //   // console.log('Pusher state:', states.previous, '→', states.current);
    // });

    pusher.connection.bind('error', (err) => {
      console.error('Pusher error:', err);
    });

    // 3. Subscribe to fixed backend channel
    const CHANNEL_NAME = 'asia899';
    const channel = pusher.subscribe(CHANNEL_NAME);

    // 🔍 Extract transaction ID from message
    const extractId = (message) => {
      if (!message) return null;

      // Match parentheses if they exist
      const match = message.match(/\((.*?)\)/);
      if (match) return match[1].trim();

      // Otherwise just take the message trimmed
      return message.trim();
    };

    const formatDate = (date) => {
      const pad = (num) => String(num).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}:${pad(date.getSeconds())}`;
    };

    // console.log('Subscribed to channel:', CHANNEL_NAME);

    // 4. Listen to event = uuid
    const handler = async (data) => {
      // console.log('Matched UUID event received!');
      // console.log('Event Data:', data);

      if (!data) return;

      setLoading?.(false);

      const isSuccess = data.success === true;

      // enqueueSnackbar(data.message || (isSuccess ? 'Success!' : 'Failed'), {
      //   variant: isSuccess ? 'success' : 'error',
      // });

      const transactionId = extractId(data.message);

      // console.log('Extracted Transaction ID:', transactionId);

      try {
        const token = localStorage.getItem('accessToken');

        const now = new Date();
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        now.setHours(23, 59, 59, 999);

        const payload = {
          'view_report[start_date]': formatDate(start),
          'view_report[end_date]': formatDate(now),
        };

        const { data: response } = await conObjForm.post('v1/report', payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log('Transaction details response:', response.data);

        const transactions = response.data?.data || [];

        // console.log('Fetched transactions:', transactions);
        // Find the specific transaction
        // transactions.forEach((item, index) => {
        //   console.log(`Transaction #${item.transaction_id} -> transaction_id: "${item.transaction_id}"`);
        // });

        const tx = transactions.find((item) => String(item.transaction_id).trim() === String(transactionId).trim());
        // console.log('Matched transaction:', tx);

        if (tx) {
          dispatch(
            openModal({
              view: 'transaction-details',
              data: tx,
            })
          );
        }
        navigate('/');
      } catch (err) {
        console.error('Failed to fetch transaction details', err);
      }
    };

    channel.bind(uuid, handler);
    // console.log('Binding to UUID:', uuid);

    // Optional: debug all events
    // channel.bind_global((eventName, data) => {
    //   console.log('--- GLOBAL EVENT ---');
    //   console.log('Event:', eventName);
    //   console.log('Data:', data);
    // });

    // 5. Cleanup
    return () => {
      // console.log('Cleaning up Pusher...');
      channel.unbind(uuid, handler);
      channel.unbind_global();
      pusher.unsubscribe(CHANNEL_NAME);

      if (pusher.connection.state === 'connected') {
        pusher.disconnect();
      }
    };
  }, [uuid, enqueueSnackbar, navigate, setLoading]);
};

export default usePusher;
